import React from "react";
import { inject } from 'mobx-react'
import { Collapse } from "reactstrap";
import { Link } from "react-router-dom";
import { IconeSetaSubir, IconeSetaDescer } from './Icones';

@inject("store")
// @observer4
export default class ItemSidebar extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);

        this.labelIcon = props.labelIcon;
        this.label = props.label;
        this.sideItensGroup = props.sideItensGroup;

        this.store = this.props.store;
        this.appStore = this.props.appStore;

        if (this.label == this.appStore.submenuAberto) {
            this.state = { submenuAberto: true };
        } else {
            this.state = { submenuAberto: false };
        }

    }


    handleClick(e) {
        this.setState({
            submenuAberto: !this.state.submenuAberto
        });
        this.appStore.submenuAberto = this.label;
        if (!this.props.isLink) {
            e.preventDefault();
        }
    }

    render() {
        const id = this.label.replace(/\s/g, '');
        const isExternal = (/^https?:\/\//.test(this.props.goTo))
        return (
            <div>
                {isExternal &&
                    <a className={"item-sidebar"}
                        href={this.props.goTo}
                        target={'_blank'}>
                        <div className="sidebar-info">
                            <span className="sidebar-item-icon">{this.labelIcon}</span>
                            <span className="sidebar-label">{this.label}</span>
                        </div>
                        <span className="sidebar-caret">
                            {this.sideItensGroup.length > 0 && (this.state.submenuAberto ? <IconeSetaSubir /> : <IconeSetaDescer />)}
                        </span>
                    </a>
                }

                {!isExternal &&
                    <Link className={this.props.selected ? "item-sidebar selected" : "item-sidebar"}
                        onClick={this.handleClick}
                        to={this.props.goTo}
                    >
                        <div className="sidebar-info">
                            <span className="sidebar-item-icon">{this.labelIcon}</span>
                            <span className="sidebar-label">{this.label}</span>
                        </div>
                        <span className="sidebar-caret">
                            {this.sideItensGroup.length > 0 && (this.state.submenuAberto ? <IconeSetaSubir /> : <IconeSetaDescer />)}
                        </span>
                    </Link>
                }

                <Collapse className="item-group" isOpen={this.state.submenuAberto}>
                    {this.sideItensGroup}
                </Collapse >
            </div>


        );
    }
}



// WEBPACK FOOTER //
// ./src/modules/comum/components/ItemSidebar.js